{
  "kampanya": {
    "Baslik": "Campaign Definitions",
    "Ad": "Campaign Name",
    "BasTarih": "Start Date",
    "BitTarih": "End Date",
    "HedefEkle": "Assign Targets",
    "Kullanici Ata": "Assign Users",
    "Kullanici Seç": "Select Staff/User",
    "Kullanici Ad Soyad": "User Full Name",
    "Hedef Tutar": "Amount (₺)",
    "Hedef Adet": "Quantity",
    "PDO Orani": "PDO Ratio (%)",
    "Urun Sec": "Product Specific",
    "Grup Sec": "Group Specific",
    "Urun Veya Grup": "Group/Product Name",
    "Filtrele": "Filter",
    "Temizle": "Clear",
    "ARA": "SEARCH",
    "Kapat": "Close",
    "Ara": "Search...",
    "Hepsi": "All",
    "Aktif": "Active",
    "Pasif": "Inactive",
    "Durum": "Status",
    "Aciklama": "Description",
    "Duzenle": "Edit",
    "Yeni Ekle": "Add New",
    "Ekle": "Add",
    "Guncelle": "Update",
    "Kaydet": "Save",
    "Iptal": "Cancel",
    "Islem": "Action",
    "Yenile": "Refresh",
    "Data Yenile": "Refresh Data",
    "Hedef yok": "No targets assigned",
    "Kullanici yok": "No users assigned",
    "Hedef Dolar": "Dollar Target ($)",
    "Hedef APE": "APE Target",
    "Tekil Kullanıcı Ekle": "Add Single User",
    "Toplu Kullanıcı Ekle (Takım/Şube)": "Add Bulk Users (Team/Branch)",
    "Takım Bazlı": "Team Based Selection",
    "Şube Bazlı": "Branch Based Selection",
    "Toplu Ekle": "Add Bulk",
    "Takım": "Team"
  }
}
